import * as marietta from "../../../..";
import { Dialog } from "../../../../core/view";
import { ThreeView } from "../../../../view3d/webcad";
import { Mode3DTool } from "../../../../view3d/webcad/util/Mode3DTool";
import { optAutoIntersectMode } from "../../../../view3d/webcad/util/Option3DInterface";
import { WizardManager } from "./WizardManager";

export class WizardStartPinDialog extends Dialog {

    constructor(draggable: boolean) {
        super(draggable);
    }

    /**
     * HTML生成
     */
    buildContent() {

        const id = 'WizardStartPinDialog';

        const title = (marietta.webcad.WebCADGlobal.language === 'jp') ? '': '';

        const contents = `
            <div class="WizardStartDialogBody">
                <div class="explanationBody">
                    ピンの編集ウィザードを開始しますか？
                    <p>※キャンセルされた場合でも、ピンの紐づけアイテムは自動的に紐づけられます。</p>
                </div>
            </div>
        `;

        const footer = `
            <button id="btnCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>
            <button id="btnStart"><span class="jp">開始する</span><span class="en">Start</span></button>
        `;

        this.createDialog(id, title, contents, footer);

        document.querySelector('#WizardStartPinDialog #btnStart')?.addEventListener('click', this.onStartButtonClicked);
        document.querySelector('#WizardStartPinDialog #btnCancel')?.addEventListener('click', this.close);
    }

    /**
     * OKボタンがクリックされた
     */
    onStartButtonClicked = () => {
        this.closeEvent();

        // 次のwizardに進む
        if (new WizardManager().getTargetPin().length == 0) ThreeView.get().wizardManager.end();
        else ThreeView.get().wizardManager.next(1);
    }

    close = () => {
        this.closeEvent();

        // 自動紐づけ
        if (new WizardManager().getTargetPin().length > 0) {
            const mode3d = new Mode3DTool();
            mode3d.setOption(<optAutoIntersectMode>{ isAutoIntersectMode: true });
            mode3d.start();
        }

        // wizardの終了
        ThreeView.get().wizardManager.end();
    }

    closeEvent() {
        super.closeEvent();
    }
}
